export default [
  {
    title: 'مدیریت اطلاع رسانی',
    icon: 'bx bx-message-dots',
    children: [
      {
        title: 'لیست اطلاع رسانی',
        route: { name: 'listDeclaration' },
        resource: 'NotificationManager',
        action: 'show',
      },
    ],
  },
]
